import type {UnidentifiedChannel, UnidentifiedMessage} from "./types"

type ChannelPresenter = {
	title: (message: UnidentifiedMessage) => string
	sourceLabel: (message: UnidentifiedMessage) => string
	senderLabel: (message: UnidentifiedMessage) => string
}

const email: ChannelPresenter = {
	title: (message) => (message.Subject?.trim() ? message.Subject : "(no subject)"),
	// The whole address, not the region suffix it once carried: a mailbox is
	// only named for a region until it is not, and NY and DEV both read as
	// countries once the rest is stripped off.
	sourceLabel: (message) => message.Mailbox,
	senderLabel: (message) =>
		message.From.Label.trim() ? `${message.From.Label} · ${message.From.Address}` : message.From.Address,
}

const sms: ChannelPresenter = {
	title: (message) => `SMS from ${message.From.Address}`,
	sourceLabel: (message) => `Our number ${message.Mailbox}`,
	senderLabel: (message) => message.From.Address,
}

function channelPresenter(channel: UnidentifiedChannel): ChannelPresenter {
	return channel === "sms" ? sms : email
}

function itemPath(channel: string, conversationID: string, providerMessageID: string): string {
	return `/inbox/${encodeURIComponent(channel)}/${encodeURIComponent(conversationID)}/${encodeURIComponent(providerMessageID)}`
}

export {channelPresenter, itemPath}
export type {ChannelPresenter}
